import React, { useEffect, useState } from "react";
import StatusDropdown from "../Shared/StatusDropdown";
// import * as Yup from "yup";
import { dropdownCategories } from "../../api/dropdownService";
import { dropdownCoupons } from "../../api/dropdownService";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../utils/errorHandler";
import SeoFields from "../../common/SEOFields";

export default function ProductForm({
  onSubmit,
  loading = false,
  backendErrors = {},
  initialData = null,
  isEdit = false,
}) {
  const navigate = useNavigate();
  const initialState = {
    productName: "",
    categoryId: "",

    // NEW FIELDS
    heading: "",
    productWeight: "",
    length: "",
    width: "",
    height: "",
    thickness: "",
    maxQuantity: "",

    // CHECKBOXES
    isFeatured: false,
    newArrival: false,

    // TEXT
    highlight: "",
    productDescription: "",
    durability: "",
    previewtext: "",

    // SEO
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    metaImage: null,

    coupons: "",
    status: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [isMetaTitleEdited, setIsMetaTitleEdited] = useState(false);
  const [isMetaDescriptionEdited, setIsMetaDescriptionEdited] = useState(false);

  useEffect(() => {
    if (!initialData) return;

    setFormData({
      productName: initialData.productName || "",

      categoryId: initialData.category || "",

      productWeight: initialData.productWeight ?? "",

      length: initialData.packageInfo?.length ?? initialData.length ?? "",

      width: initialData.packageInfo?.width ?? initialData.width ?? "",

      height: initialData.packageInfo?.height ?? initialData.height ?? "",

      thickness: initialData.packageInfo?.thickness ?? initialData.thickness ?? "",

      maxQuantity: initialData.maxQuantity ?? "",

      isFeatured: Boolean(initialData.isFeatured),
      newArrival: Boolean(initialData.newArrival),

      highlight: initialData.highlight || "",
      productDescription: initialData.productDescription || "",
      durability: initialData.durability || "",
      previewtext: initialData.previewtext || initialData.preview || "",
      status: initialData.status || "ACTIVE",
    });
  }, [initialData]);
  useEffect(() => {
    if (!isMetaTitleEdited && formData.productName) {
      setFormData((prev) => ({
        ...prev,
        metaTitle: formData.productName,
      }));
    }
  }, [formData.productName, isMetaTitleEdited]);
  useEffect(() => {
    if (!isMetaDescriptionEdited && formData.productDescription) {
      setFormData((prev) => ({
        ...prev,
        metaDescription: formData.productDescription,
      }));
    }
  }, [formData.productDescription, isMetaDescriptionEdited]);

  const fetchCategories = async () => {
    try {
      const response = await dropdownCategories();
      setCategories(response?.data || []);
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };
  const fetchCoupons = async () => {
    try {
      const response = await dropdownCoupons();
      setCoupons(response.data || []);
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };
  useEffect(() => {
    fetchCategories();
    fetchCoupons();
  }, []);
  // const validationSchema = Yup.object({
  //   productName: Yup.string()
  //     .trim()
  //     .max(50, "Product name must be at most 50 characters")
  //     .required("Product name is required"),
  //   categoryId: Yup.string().required("Category is required"),
  //   highlight: Yup.string().required("Highlight is required"),
  //   durability: Yup.string().required("Durability is required"),
  //   productDescription: Yup.string().required(
  //     "Product description is required",
  //   ),
  //   metaTitle: Yup.string().required("Meta title is required"),
  //   metaKeywords: Yup.string().required("Meta keywords are required"),
  //   metaDescription: Yup.string().required("Meta description is required"),
  //   coupons: Yup.string().required("Coupon is required"),
  // });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "metaTitle") {
      setIsMetaTitleEdited(true);
    }

    if (name === "metaDescription") {
      setIsMetaDescriptionEdited(true);
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setErrors({});

      const payload = {
        productName: formData.productName,
        category: formData.categoryId,

        packageInfo: {
          length: Number(formData.length),
          width: Number(formData.width),
          height: Number(formData.height),
          thickness: Number(formData.thickness),
        },

        productWeight: Number(formData.productWeight),
        maxQuantity: Number(formData.maxQuantity),

        isFeatured: formData.isFeatured,
        newArrival: formData.newArrival,

        highlight: formData.highlight,
        productDescription: formData.productDescription,
        durability: formData.durability,
        preview: formData.previewtext,

        coupons: formData.coupons ? [formData.coupons] : [],

        ...(isEdit && { status: formData.status }),
      };
      await onSubmit(payload);
      setSuccessMessage("Product Added Successfully");
      setFormData(initialState);
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      if (error.inner) {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      }
    }
  };
  return (
    <div className="container">
      <div className="card shadow border-0">
        {/* SUCCESS MESSAGE */}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        <form onSubmit={handleSubmit}>
          {/* PRODUCT NAME */}
          <div className="row">
            <div className="col-md-12 mb-2 h80">
              <label className="form-label">
                Product Name<span className="error">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  errors.productName || backendErrors?.productName ? "is-invalid" : ""
                }`}
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                maxLength={50}
              />
              {errors.productName && <div className="invalid-feedback">{errors.productName}</div>}
              {!errors.productName && backendErrors?.productName && (
                <div className="invalid-feedback d-block">{backendErrors.productName}</div>
              )}
            </div>
          </div>

          {/* PRODUCT DESCRIPTION */}
          <div className="row">
            <div className="col-md-12 mb-2 h120">
              <label className="form-label">
                Product Description
                <span className="error">*</span>
              </label>
              <textarea
                rows="4"
                className={`form-control ${
                  errors.productDescription || backendErrors?.productDescription ? "is-invalid" : ""
                }`}
                name="productDescription"
                value={formData.productDescription}
                onChange={handleChange}
              />
              {errors.productDescription && (
                <div className="invalid-feedback">{errors.productDescription}</div>
              )}
              {!errors.productDescription && backendErrors?.productDescription && (
                <div className="invalid-feedback d-block">{backendErrors.productDescription}</div>
              )}
            </div>
          </div>

          {/* CATEGORY + COUPON */}
          <div className="row">
            {/* CATEGORY */}
            <div className="col-md-6 mb-2 h80">
              <label className="form-label">
                Category<span className="error">*</span>
              </label>
              <select
                className={`form-select ${
                  errors.categoryId || backendErrors?.categoryId ? "is-invalid" : ""
                }`}
                name="categoryId"
                value={formData.categoryId}
                onChange={handleChange}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category._id} value={category.slug}>
                     {category.type} - {category.name}
                  </option>
                ))}
              </select>
              {errors.categoryId && <div className="invalid-feedback">{errors.categoryId}</div>}
              {!errors.categoryId && backendErrors?.categoryId && (
                <div className="invalid-feedback d-block">{backendErrors.categoryId}</div>
              )}
            </div>
            {/* COUPONS */}
            <div className="col-md-6 mb-2 h80">
              <label className="form-label">
                Coupons<span className="error">*</span>
              </label>
              <select
                className={`form-select ${
                  errors.coupons || backendErrors?.coupons ? "is-invalid" : ""
                }`}
                name="coupons"
                value={formData.coupons}
                onChange={handleChange}
              >
                <option value="">Select Coupon</option>

                {coupons?.map((coupon) => (
                  <option key={coupon._id} value={coupon._id}>
                    {coupon._id}
                  </option>
                ))}
              </select>
              {errors.coupons && <div className="invalid-feedback">{errors.coupons}</div>}
              {!errors.coupons && backendErrors?.coupons && (
                <div className="invalid-feedback d-block">{backendErrors.coupons}</div>
              )}
            </div>
          </div>
          {/* CHECKBOXES */}
          <div className="row align-items-center mt-3 mb-3">
            <div className="col-md-3 position-relative">
              <div className="form-check" style={{ position: "relative", zIndex: 10 }}>
                <input
                  id="isFeatured"
                  type="checkbox"
                  name="isFeatured"
                  checked={formData.isFeatured}
                  onChange={handleChange}
                  style={{
                    position: "relative",
                    zIndex: 11,
                    pointerEvents: "auto",
                    cursor: "pointer",
                  }}
                />

                <label
                  htmlFor="isFeatured"
                  className="form-check-label"
                  style={{ cursor: "pointer" }}
                >
                  Featured Product
                </label>
              </div>
            </div>

            <div className="col-md-3 position-relative">
              <div className="form-check" style={{ position: "relative", zIndex: 10 }}>
                <input
                  id="newArrival"
                  type="checkbox"
                  name="newArrival"
                  checked={formData.newArrival}
                  onChange={handleChange}
                  style={{
                    position: "relative",
                    zIndex: 11,
                    pointerEvents: "auto",
                    cursor: "pointer",
                  }}
                />

                <label
                  htmlFor="newArrival"
                  className="form-check-label"
                  style={{ cursor: "pointer" }}
                >
                  New Arrival
                </label>
              </div>
            </div>

            <div className="col-md-6">
              <label className="form-label">
                Preview Text <span className="error">*</span>
              </label>

              <textarea
                className="form-control"
                name="previewtext"
                value={formData.previewtext}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* HIGHLIGHT + DURABILITY */}
          <div className="row">
            {/* HIGHLIGHT */}

            <div className="col-md-6 mb-2 h120">
              <label className="form-label">
                Highlight<span className="error">*</span>
              </label>
              <textarea
                rows="4"
                className={`form-control ${
                  errors.highlight || backendErrors?.highlight ? "is-invalid" : ""
                }`}
                name="highlight"
                value={formData.highlight}
                onChange={handleChange}
              />
              {errors.highlight && <div className="invalid-feedback">{errors.highlight}</div>}
              {!errors.highlight && backendErrors?.highlight && (
                <div className="invalid-feedback d-block">{backendErrors.highlight}</div>
              )}
            </div>
            {/* DURABILITY */}
            <div className="col-md-6 mb-2 h120">
              <label className="form-label">
                Durability<span className="error">*</span>
              </label>
              <textarea
                rows="4"
                className={`form-control ${
                  errors.durability || backendErrors?.durability ? "is-invalid" : ""
                }`}
                name="durability"
                value={formData.durability}
                onChange={handleChange}
              />
              {errors.durability && <div className="invalid-feedback">{errors.durability}</div>}
              {!errors.durability && backendErrors?.durability && (
                <div className="invalid-feedback d-block">{backendErrors.durability}</div>
              )}
            </div>
          </div>
          {isEdit && (
            <div className="row">
              <div className="col-md-6 mt-3 h80">
                <label className="form-label">
                  Status<span className="error">*</span>
                </label>

                <StatusDropdown
                  className={`form-select ${
                    errors.status || backendErrors?.status ? "is-invalid" : ""
                  }`}
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                 />

                {errors.status && <div className="invalid-feedback">{errors.status}</div>}

                {!errors.status && backendErrors?.status && (
                  <div className="invalid-feedback d-block">{backendErrors.status}</div>
                )}
              </div>
            </div>
          )}
          {/* Heading */}
          <h6 className="mt-5 fw-bold">Package Info</h6>
          <div className="row">
            <div className="col-md-3 mb-2">
              <label> width </label>
              <input
                type="text"
                className="form-control"
                name="width"
                value={formData.width}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3 mb-2">
              <label>height</label>
              <input
                type="text"
                className="form-control"
                name="height"
                value={formData.height}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3 mb-2">
              <label>length</label>
              <input
                type="text"
                className="form-control"
                name="length"
                value={formData.length}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3 mb-2">
              <label>thinkess</label>
              <input
                type="text"
                className="form-control"
                name="thickness"
                value={formData.thickness}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3 mb-2">
              <label>Product Weight</label>
              <input
                type="number"
                className={`form-control ${
                  errors.productWeight || backendErrors?.productWeight ? "is-invalid" : ""
                }`}
                name="productWeight"
                value={formData.productWeight}
                onChange={handleChange}
                min="0"
                step="any"
                placeholder="Enter product weight"
              />

              {errors.productWeight && (
                <div className="invalid-feedback">{errors.productWeight}</div>
              )}

              {!errors.productWeight && backendErrors?.productWeight && (
                <div className="invalid-feedback d-block">{backendErrors.productWeight}</div>
              )}
            </div>

            <div className="col-md-3 mb-2 h80">
              <label>Max Quantity</label>
              <input
                type="number"
                className={`form-control ${
                  errors.maxQuantity || backendErrors?.maxQuantity ? "is-invalid" : ""
                }`}
                name="maxQuantity"
                value={formData.maxQuantity}
                onChange={handleChange}
                min="1"
                placeholder="Enter max quantity"
              />

              {errors.maxQuantity && <div className="invalid-feedback">{errors.maxQuantity}</div>}

              {!errors.maxQuantity && backendErrors?.maxQuantity && (
                <div className="invalid-feedback d-block">{backendErrors.maxQuantity}</div>
              )}
            </div>
          </div>

          {/* BUTTONS */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              {loading ? "Saving..." : isEdit ? "Update Product" : "Submit"}
            </button>

            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#032B4D", color: "#fff" }}
              onClick={() => navigate("/Product")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
